export enum QrStatus {
  STARTED = 'STARTED',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
  REJECTED_BY_USER = 'REJECTED_BY_USER',
  ACCEPTED = 'ACCEPTED',
  OUTDATED = 'OUTDATED',
  UNKNOWN = '',
}
